import { Tooltip, Typography } from '@mui/material';
import { IconLibrary } from '@product-framework/index';
import { useLocalization } from '@ui-framework/index';

function PasswordInstructions() {
  const { formatMessage } = useLocalization();

  const passwordValidationMessages = [
    formatMessage({
      id: 'PASSWORD_MIN_MAX_LENGTH',
      defaultMessage: 'Must contain 8-64 characters',
    }),
    formatMessage({
      id: 'PASSWORD_UPPERCASE',
      defaultMessage: 'Must contain at least one uppercase letter',
    }),
    formatMessage({
      id: 'PASSWORD_NUMBER',
      defaultMessage: 'Must contain at least one number',
    }),
    formatMessage({
      id: 'PASSWORD_NOT_EQUAL_EMAIL',
      defaultMessage: 'Must not be the same as your email address',
    }),
  ];

  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2" gutterBottom>
            {formatMessage({
              id: 'PASSWORD_CONDITIONS_TITLE',
              defaultMessage: 'Password Requirements',
            })}
          </Typography>
          <ul style={{ paddingLeft: '1.2em' }}>
            {passwordValidationMessages.map((msg, idx) => (
              <li key={msg || idx}>{msg}</li>
            ))}
          </ul>
        </>
      }
      arrow>
      <IconLibrary.Info color="info" sx={{ fontSize: 18, ml: 0.4, mb: -0.5 }} />
    </Tooltip>
  );
}

export default PasswordInstructions;
